import { notification } from "antd";
import { NOTIFICATION_MESSAGES, NOTIFICATION_CONFIG } from "./constants";

export interface FileImageCoverProps {
  id: string;
  ext: string;
}

export const successNotification = () =>
  notification["success"]({
    message: NOTIFICATION_MESSAGES.success.create.title,
    description: NOTIFICATION_MESSAGES.success.create.description,
    placement: NOTIFICATION_CONFIG.placement,
    duration: NOTIFICATION_CONFIG.duration,
  });

export const errorNotification = () =>
  notification["error"]({
    message: NOTIFICATION_MESSAGES.error.general.title,
    description: NOTIFICATION_MESSAGES.error.general.description,
    placement: NOTIFICATION_CONFIG.placement,
    duration: NOTIFICATION_CONFIG.duration,
  });

export const updatedNotification = () =>
  notification["success"]({
    message: NOTIFICATION_MESSAGES.success.update.title,
    description: NOTIFICATION_MESSAGES.success.update.description,
    placement: NOTIFICATION_CONFIG.placement,
    duration: NOTIFICATION_CONFIG.duration,
  });
